import React, { Component } from 'react'
import Scroll from 'react-scroll'
import config from '../config.json'
import hasSlidebarRightAndSecond from '../hoc/hasSlidebarRightAndSecond'
import Highlight from './Highlight.jsx'
import hasOpenInformationAndDetails from '../hoc/hasOpenInformationAndDetails'
import { trackMovieInformationOpen } from '../tracking'
import getMovieLink from '../functions/getMovieLink'
import SlideActiveItem from '../SliderGeneral/SlideActiveItem'
const breakpoints = config.breakpoints

let Element = Scroll.Element

class SliderHighlight extends Component {
    constructor(props) {
        super(props)

        this.state = {
            currentDateActive: '',
        }

        this.toggleMovieDatesOnMobileView = this.toggleMovieDatesOnMobileView.bind(this)
    }

    toggleMovieDatesOnMobileView(date) {        
        this.setState({
            currentDateActive: date
        })
    }

    componentDidUpdate(prevProps) {
        const {currentActiveSelection, selectionId, activeItem, onCloseInformation} = this.props
        if (currentActiveSelection !== prevProps.currentActiveSelection) {
            if(currentActiveSelection && currentActiveSelection !== selectionId && activeItem) {
                onCloseInformation()
            }
        }
    }

    render() {
        const { 
            items, 
            moviesData, 
            moviesRoutesData,
            highlights, 
            elbenwald,
            activeDetailsItem,
            scrollToPosition, 
            displaySidebarRight, 
            displaySidebarRightSecond,  
            highlightAppearance,
            hiddenAttributes,
            isMobile, 
            detailsStyling,
            title='',
            backgroundVisualsSettings,
            translation,
            activeItem,  
            activePerformance, 
            performancePageOpen,
            onCloseDetails,
            attributeStyling,
            onOpenDetails,
            filterType,
            filterValue,
            onOpenPerformancePage,
            onClosePerformancePage,
            onCloseInformation,
            onOpenInformation,
            informationStyling,
            theme,
            ignoreAttributesForPerformanceFilter
        } = this.props
        
        const { currentDateActive } = this.state

        const eventOrigins = {
            highlight:                  'Startseite, Highlight "' + title + '", Highlight',
            information:                'Startseite, Highlight "' + title + '", Film Information',
            informationSlidebar:        'Startseite, Highlight "' + title + '", Film Imformation/rechte Slidebar',
            performance:                'Startseite, Highlight "' + title + '", Film Vorführung',
            performanceSlidebar:        'Startseite, Highlight "' + title + '", Film Vorführung/rechte Slidebar',
            details:                    'Startseite, Highlight "' + title + '", Film Details',
            detailsSlidebar:            'Startseite, Highlight "' + title + '", Film Details/rechte Slidebar',
        }

        const itemLink = getMovieLink(activeItem, moviesRoutesData, translation)
        const detailsOpen = activeDetailsItem === activeItem

    
        return (
            <div className={scrollToPosition}>
            {/* {title && <h2 className="slider-title title-large">{title}</h2>} */}
                <div className={"slider-wrapper " + highlightAppearance}>
                    <Element name={scrollToPosition}></Element>
                    <Highlight
                        items={items}
                        theme={theme}
                        moviesData={moviesData}
                        highlightAppearance={highlightAppearance}
                        hiddenAttributes={hiddenAttributes}
                        attributeStyling={attributeStyling}
                        highlights={highlights}
                        backgroundVisualsSettings={backgroundVisualsSettings}
                        translation={translation}
                        scrollToPosition={scrollToPosition}
                        isMobile={isMobile}
                        onClickItem={trackMovieInformationOpen(onOpenInformation, eventOrigins.highlight)}
                        // onOpenPerformancePage={onOpenPerformancePage}
                    />
                    <SlideActiveItem
                        itemLink={itemLink}
                        activeItem={activeItem}
                        theme={theme}
                        hiddenAttributes={hiddenAttributes}
                        activePerformance={activePerformance}
                        currentDateActive={currentDateActive}
                        ignoreAttributesForPerformanceFilter={ignoreAttributesForPerformanceFilter}
                        filterValue={filterValue}
                        isMobile={isMobile}
                        filterType={filterType}
                        scrollToPosition={scrollToPosition}
                        detailsStyling={detailsStyling}
                        eventOrigins={eventOrigins}
                        moviesData={moviesData}
                        elbenwald={elbenwald}
                        informationStyling={informationStyling}
                        translation={translation}
                        attributeStyling={attributeStyling}
                        displaySidebarRight={displaySidebarRight}
                        displaySidebarRightSecond={displaySidebarRightSecond}
                        performancePageOpen={performancePageOpen}
                        detailsOpen={detailsOpen}
                        onCloseInformation={onCloseInformation}
                        onOpenDetails={onOpenDetails}
                        onCloseDetails={onCloseDetails}
                        onOpenPerformancePage={onOpenPerformancePage}
                        onClosePerformancePage={onClosePerformancePage}
                        toggleMovieDatesOnMobileView={this.toggleMovieDatesOnMobileView}
                    />
                </div>
            </div>
        )
    }
}


export default hasSlidebarRightAndSecond({breakpoint:  breakpoints.slidebarRight})(hasOpenInformationAndDetails(SliderHighlight))